const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

export function getToken() {
  return localStorage.getItem('eleven_games_token');
}

export function setToken(token) {
  if (token) localStorage.setItem('eleven_games_token', token);
  else localStorage.removeItem('eleven_games_token');
}

export async function api(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  } catch (err) {
    const hint =
      process.env.NODE_ENV === 'production'
        ? 'Check that the API is running and nginx proxies /api to the backend.'
        : 'Start the backend with: cd backend && npm run dev';
    throw new Error(`Cannot reach the server at ${API_BASE}. ${hint}`);
  }

  if (res.status === 204) return null;
  const text = await res.text();
  let data = {};
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      if (!res.ok) {
        const plain = text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        throw new Error(plain.slice(0, 160) || res.statusText);
      }
    }
  }
  if (!res.ok) throw new Error(data.error || res.statusText || `Request failed (${res.status})`);
  return data;
}

export { API_BASE };
